import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import graphReducer from './slices/graphSlice';
import stockReducer from './slices/stockSlice';

export const store = configureStore({
  reducer: {
    graph: graphReducer,
    stock: stockReducer,
  },
});

// Тип состояния корня
export type RootState = ReturnType<typeof store.getState>;

// Тип диспетчера
export type AppDispatch = typeof store.dispatch;

// Тип для Thunk
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
